<template>
  <div class="page">
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="搜索来访者姓名/就诊号/手机号/咨询师" clearable class="search" @clear="fetchData" @keyup.enter.native="fetchData" />
    </div>

    <el-table :data="items" stripe v-loading="loading" class="table" @row-click="goDetail">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="visitor_name" label="来访者" width="160" />
      <el-table-column prop="scale_title" label="量表" min-width="200" />
      <el-table-column label="状态" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="statusType(row.status)" size="small" effect="dark">
            {{ formatStatus(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="200">
        <template slot-scope="{ row }">{{ formatDateTime(row.created_at) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="{ row }">
          <el-button size="mini" @click.stop="goDetail(row)">查看</el-button>
          <el-button 
            v-if="row.status === 'PENDING'"
            size="mini" 
            type="danger" 
            plain
            style="margin-left: 8px;"
            @click.stop="handleCancel(row)">
            取消
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="page"
        :total="total"
        @current-change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import { getAssessments, cancelAssessment } from '@/api/assessments'
import { notifyApiError } from '@/utils/notifyApiError'

export default {
  name: 'Assessments',
  data() {
    return {
      loading: false,
      items: [],
      page: 1,
      pageSize: 10,
      total: 0,
      keyword: '',
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    formatStatus(v) {
      if (v === 'PENDING') return '待测评'
      if (v === 'COMPLETED') return '已完成'
      if (v === 'CANCELED') return '已取消'
      return v || ''
    },
    statusType(v) {
      if (v === 'PENDING') return 'warning'
      if (v === 'COMPLETED') return 'success'
      if (v === 'CANCELED') return 'info'
      return 'info'
    },
    formatDateTime(v) {
      if (!v) return ''
      const d = new Date(v)
      if (Number.isNaN(d.getTime())) return v
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(
        d.getMinutes()
      )}`
    },
    async fetchData() {
      this.loading = true
      try {
        const params = { page: this.page }
        if (this.keyword) params.search = this.keyword
        const resp = await getAssessments(params)
        this.items = resp.data.results || []
        this.total = resp.data.count || 0
      } catch (e) {
        this.items = []
        this.total = 0
        if (e && e.response && e.response.status === 401) return
        notifyApiError(e, '获取测评记录失败')
      } finally {
        this.loading = false
      }
    },
    async handleCancel(row) {
      try {
        await this.$confirm('确定要取消该测评吗？取消后链接将失效。', '提示', {
          confirmButtonText: '确定取消',
          cancelButtonText: '暂不取消',
          type: 'warning'
        })
        await cancelAssessment(row.id)
        this.$message.success('已取消')
        this.fetchData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
          notifyApiError(e, '取消失败')
        }
      }
    },
    onPageChange(p) {
      this.page = p
      this.fetchData()
    },
    goDetail(row) {
      this.$router.push(`/app/assessments/${row.id}`)
    },
  },
}
</script>

<style scoped>
.toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}
.search {
  max-width: 360px;
}
.table {
  background: var(--bg-card);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
}
.pager {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
</style>
